<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>A huge thank you to Cherie Michele Basile for her expertise in editing this book for me.</p><br/>
<p style="text-indent: 0em">My daughters, Rachel Gerber and Toni Symmonds, for proof reading and their never-ending support.</p><br/>
<p style="text-indent: 0em">My darling sister, Avril, for her never failing, support and encouragement</p><br/>
<p style="text-indent: 0em">My dear friend, Val Smetheram, for her advice and encouragement.</p><br/>
<p style="text-indent: 0em">My friend, Stephen Scott, from ‘Yet Another Creative’, thank you for setting up my amazing website and other creative ideas which have been invaluable.</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?04c25b82